module.exports = __webpack_public_path__ + "img/Falkberget_Bergstaddikteren.fab4cdf2.jpg";